import { render, staticRenderFns } from "./ExportType.vue?vue&type=template&id=1812a76c&scoped=true&"
import script from "./ExportType.vue?vue&type=script&lang=js&"
export * from "./ExportType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1812a76c",
  null
  
)

export default component.exports